import enrollmentsService from '../services/enrollment'
import { notification } from 'antd'
import { GET_ALL } from '../actions/notification';
import usersService from '../services/users';

const LOAD_PARTICIPANTS = 'LOAD_PARTICIPANTS'
const GET_ALL_PARTICIPANTS = 'GET_ALL_PARTICIPANTS'
const GET_ALL_INSTRUCTORS = 'GET_ALL_INSTRUCTORS'

const participantsReducer = (state = { data: [], loading: false }, action) => {
  switch (action.type) {
    case LOAD_PARTICIPANTS:
      return { data: [], loading: true }
    case GET_ALL_PARTICIPANTS:
      return { data: action.data, loading: false }
    case GET_ALL_INSTRUCTORS:
      return { data: action.data, loading: false }
    default:
      return state
  }
}

export const getAllParticipants = (courseId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOAD_PARTICIPANTS })
      const response = await enrollmentsService.getEnrollments(courseId)

      dispatch({ type: GET_ALL_PARTICIPANTS, data: response })
    } catch (error) {
      console.log(error)
      notification.error({
        message: "Couldn't load Participants check your connection"
      })
    }
  }
}

export const updatePrivilege = (courseId, enrollmentId, enrolledAs) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOAD_PARTICIPANTS })
      const response = await enrollmentsService.updateEnrollment(
        courseId,
        enrollmentId,
        enrolledAs
      )

      dispatch({ type: GET_ALL_PARTICIPANTS, data: response })
      notification.success({
        message: 'Privilege updated successfully'
      })
    } catch (error) {
      console.log(error)
      notification.error({
        message: "Couldn't update privilege check your connection"
      })
    }
  }
}

export const getAllInstructors = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOAD_PARTICIPANTS })
      const response = await usersService.getAllInstructors()
      dispatch({ type: GET_ALL_PARTICIPANTS, data: response })
    } catch (error) {
      console.log(error)
      notification.error({
        message: "Can't fetch instructors"
      })
    }
  }
}

export const toggleUserStatus = (userId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOAD_PARTICIPANTS })
      const response = await usersService.toggleUserStatus(userId)
      dispatch({ type: GET_ALL_PARTICIPANTS, data: response })
      notification.success({
        message: 'User status updated successfully'
      })
    } catch (error) {
      console.error('Error toggling user status:', error)
      notification.error({
        message: "Couldn't toggle user status. Please try again."
      })
    }
  }
}

export default participantsReducer
